import { useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { selectors } from '~/store/state-selectors';
const EMPTY_TEMPLATES = [];
export const useCustomPageTemplates = function useCustomPageTemplates() {
    let { enabled = true, refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const isEnabled = enabled && !!businessId;
    const { data, isLoading, refresh } = useQueryState({
        queryKey: [
            QueryKeys.CustomPageTemplates,
            businessId
        ],
        queryFn: ()=>api.customPageTemplates.getAll(businessId),
        enabled: isEnabled,
        refreshOnHookMount
    });
    return {
        templates: data !== null && data !== void 0 ? data : EMPTY_TEMPLATES,
        isLoading: isLoading || !isEnabled,
        refresh
    };
};
